import React from 'react';
import type { ToastItem } from '../../../shared/hooks/useToast';

interface ToastContainerProps {
  toasts: ToastItem[];
  onDismiss: (id: string) => void;
}

export const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onDismiss }) => (
  <div className="fixed top-4 right-4 z-50 flex flex-col gap-3 max-w-sm w-full pointer-events-none">
    {toasts.map(t => (
      <div
        key={t.id}
        className={`pointer-events-auto p-4 rounded-xl shadow-lg border backdrop-blur-md flex gap-3 toast-slide-in transition duration-300 ${
          t.type === 'success'
            ? 'bg-white/95 border-emerald-100 text-emerald-800 shadow-emerald-500/10'
            : t.type === 'danger'
              ? 'bg-white/95 border-red-100 text-red-800 shadow-red-500/10'
              : 'bg-white/95 border-amber-100 text-amber-800 shadow-amber-500/10'
        }`}
      >
        {/* Icon */}
        <div className="flex-shrink-0 mt-0.5">
          {t.type === 'success' && (
            <svg className="w-5 h-5 text-emerald-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          )}
          {t.type === 'danger' && (
            <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          )}
          {t.type === 'warning' && (
            <svg className="w-5 h-5 text-amber-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
          )}
        </div>

        {/* Content */}
        <div className="flex-grow">
          <h4 className="font-bold text-sm text-gray-900">{t.message}</h4>
          {t.description && (
            <p className="text-xs text-gray-500 mt-1 leading-relaxed">{t.description}</p>
          )}
        </div>

        {/* Close button */}
        <button
          onClick={() => onDismiss(t.id)}
          className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
    ))}
  </div>
);
